import React from "react";
import { Box, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import EmptyState from "../Design/EmptyState";
import { useSurfaces } from "../../theme/surfaces";
import { radius } from "../../theme/tokens";

/**
 * Shown when a route's privilege guard denies access.
 *
 * The previous version was raw inline styles with `color: "black"`, which made
 * the explanation unreadable in dark mode. It now uses the shared state
 * treatment and follows the palette.
 *
 * Wording and behaviour are unchanged: this component still only reports the
 * denial. It does not check, grant or alter any permission.
 */
const AccessDenied = () => {
  const navigate = useNavigate();
  const s = useSurfaces();

  return (
    <Box sx={{ display: "grid", placeItems: "center", py: { xs: 4, md: 8 } }}>
      <Box
        sx={{
          ...s.card,
          borderRadius: `${radius.xl}px`,
          maxWidth: 520,
          width: "100%",
          px: 3,
        }}
      >
        <EmptyState
          variant="error"
          icon={<LockOutlinedIcon />}
          title="Access denied"
          description="You do not have the permissions needed to open this page. If you believe this is an error, contact your administrator."
          action={
            <Box sx={{ display: "flex", gap: 1.25, flexWrap: "wrap", justifyContent: "center" }}>
              <Button variant="outlined" onClick={() => navigate(-1)}>
                Go back
              </Button>
              <Button variant="contained" onClick={() => navigate("/dashboard")}>
                Go to dashboard
              </Button>
            </Box>
          }
        />
      </Box>
    </Box>
  );
};

export default AccessDenied;
